import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'alfa';

import * as serviceWorker from './serviceWorker';
import mainStore from './store';
import App from './app';
import './i18n';

ReactDOM.render(
  <Provider data={mainStore}>
    <App />
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
